import React, { useState } from 'react';
import { Typography, Card, CardBody, CardTitle, Popover, } from '@one-thd/sui-atomic-components';
import { ErrorFilled, WarningFilled } from '@one-thd/sui-icons';
import { Pagination } from '../shared/pagination/Pagination';
import { LoginToBusinessAccount } from '../../api/b2b/account';
import { FetchIndividualSpendAccounts } from '../../hooks/linked-accounts';
import { getSvocId } from '../../utils/user';
import { SectionHeader } from '../shared/section-header/SectionHeader';
import { SpendByIndividualAccountsSkeleton } from './LinkedAccountsSkeleton';
import { floorNumberWithCommas, formatPhoneNumber, getChannelID, getNumPages, } from '../../utils/general';
import { getNinetyDayTokenFromSAS } from '../../utils/cookie-helper';
var createAddressElement = function (companyAddress) {
    if (companyAddress) {
        var cityName = companyAddress.cityName, stateCode = companyAddress.stateCode, postalCode = companyAddress.postalCode;
        return (React.createElement("div", null,
            React.createElement("div", { className: "sui-inline-flex" }, "".concat(cityName, ", ").concat(stateCode, " ").concat(postalCode))));
    }
    return undefined;
};
/**
 *
 * @param
 * @returns
 */
var yearlySpentAmount = function (spend) {
    return (React.createElement("div", { className: "sui-flex sui-justify-center" },
        React.createElement("span", { className: "currency" }, "$"),
        React.createElement(Typography, null, floorNumberWithCommas(spend, 0))));
};
var renderPreviousSpent = function (spend) {
    return spend[0].yearlySpend.map(function (yearlySpend) {
        if (!yearlySpend.isCurrentYear) {
            return (React.createElement("div", null,
                React.createElement(Typography, null, "".concat(yearlySpend.year, " Spend")),
                yearlySpentAmount(yearlySpend.spend)));
        }
        return undefined;
    });
};
var renderCurrentSpent = function (spend) {
    return spend[0].yearlySpend.map(function (yearlySpend) {
        if (yearlySpend.isCurrentYear) {
            return (React.createElement("div", null,
                React.createElement(Typography, null, "".concat(yearlySpend.year, " Spend")),
                yearlySpentAmount(yearlySpend.spend)));
        }
        return undefined;
    });
};
var loginIntoLinkedAccount = function (familyMember, memberCount) {
    var requestPayload = {
        userCustomerRequest: {
            noOfCustomers: memberCount,
            deviceId: getChannelID(),
            ninetyDayToken: getNinetyDayTokenFromSAS(),
        },
    };
    LoginToBusinessAccount(requestPayload, familyMember.customerAccountId);
};
var renderSpendByIndividualAccountCard = function (familyMembers, memberCount) {
    return familyMembers.map(function (familyMember, index) {
        var companyName = familyMember.companyName, companyPhoneNumber = familyMember.companyPhoneNumber, companyAddress = familyMember.companyAddress, spends = familyMember.spends;
        return (React.createElement(Card, { key: "individual-account-card-".concat(index), className: "sui-w-full" },
            React.createElement(CardTitle, { header: companyName }),
            React.createElement(CardBody, null,
                React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement("div", null,
                        React.createElement(Typography, null, companyPhoneNumber && formatPhoneNumber(companyPhoneNumber)),
                        React.createElement(Typography, null, createAddressElement(companyAddress))),
                    renderPreviousSpent(spends),
                    renderCurrentSpent(spends)),
                React.createElement("div", { style: { paddingTop: 10 } },
                    ' ',
                    React.createElement("button", { type: "button", className: "sui-no-underline sui-hover:underline", style: { color: 'rgb(62, 118, 151)' }, onClick: function () { return loginIntoLinkedAccount(familyMember, memberCount); } }, "View Account")))));
    });
};
var helpPopover = function (handleClose, anchorElement, open) { return (React.createElement(Popover, { anchorEl: anchorElement, id: "right-popover", open: open, onClose: handleClose, placement: "right", title: "Tracking Spend for Individual Accounts" },
    React.createElement(Typography, { variant: "body-xs" },
        "Includes transactions made with Pro Xtra ID or registered tender. Excludes taxes, shipping fees, returns, and gift card purchases. ",
        React.createElement("br", null),
        React.createElement("br", null),
        "For full details, see the",
        ' ',
        React.createElement("a", { href: "https://www.homedepot.com/c/ProXtra_TermsandConditions", style: { color: '#3E7697' } }, "Pro Xtra Program Terms & Conditions")))); };
var renderWarningMessage = function () {
    return (React.createElement("div", { className: "sui-inline-flex", style: { paddingLeft: 10 } },
        React.createElement(ErrorFilled, { color: "warning" }),
        React.createElement("p", { style: { paddingTop: 5, color: '#8f6e2e' } },
            React.createElement("b", null, "Warning!"),
            " Some of the information my not be available. Please try again later.")));
};
var getMemberCount = function (individualSpendAccountsData) {
    return individualSpendAccountsData
        ? Number(individualSpendAccountsData.memberCount)
        : 0;
};
var renderLogic = function (individualSpendAccountsData, individualSpendAccountsError, individualSpendAccountsLoaded, currentPage, setCurrentPage) {
    /**
     * Error, loaded, and successful states
     */
    if (individualSpendAccountsLoaded) {
        if (individualSpendAccountsError && individualSpendAccountsData === null) {
            renderWarningMessage();
        }
        return (individualSpendAccountsData && (React.createElement(React.Fragment, null,
            individualSpendAccountsData.isPartialSuccess && (React.createElement("span", { className: "sui-text-warning" },
                React.createElement(WarningFilled, { size: "small", color: "warning" }),
                React.createElement("strong", null, " Warning! "),
                "Some of the information may not be available. Please try again later.")),
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sui-grid md:sui-grid-cols-1 lg:sui-grid-cols-2 sui-gap-6" }, renderSpendByIndividualAccountCard(individualSpendAccountsData.familyMembers, individualSpendAccountsData.memberCount)),
                Pagination({
                    nPages: getNumPages(20, getMemberCount(individualSpendAccountsData)),
                    page: currentPage,
                    onChangePage: function (selectedPage) {
                        setCurrentPage(selectedPage);
                    },
                })))));
    }
    return React.createElement(SpendByIndividualAccountsSkeleton, null);
};
var SpendByIndividualAccountElement = function (props) {
    var setHierarchyName = props.setHierarchyName;
    var _a = useState(1), currentPage = _a[0], setCurrentPage = _a[1];
    var request = {
        familyMembersRequest: {
            customerAccountId: getSvocId() || '',
            pageSize: 20,
            pageNumber: currentPage,
        },
    };
    var _b = useState(null), anchorElement = _b[0], setAnchorElement = _b[1];
    var handleClick = function (event) {
        setAnchorElement(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorElement(null);
    };
    var open = Boolean(anchorElement);
    var _c = FetchIndividualSpendAccounts(request, setHierarchyName), individualSpendAccountsData = _c.individualSpendAccountsData, individualSpendAccountsError = _c.individualSpendAccountsError, individualSpendAccountsLoaded = _c.individualSpendAccountsLoaded;
    return (React.createElement(React.Fragment, null,
        React.createElement(SectionHeader, { title: "Spend By Individual Accounts", toolTipComponent: helpPopover(handleClose, anchorElement, open), handleClick: handleClick }),
        renderLogic(individualSpendAccountsData, individualSpendAccountsError, individualSpendAccountsLoaded, currentPage, setCurrentPage)));
};
export default SpendByIndividualAccountElement;
